/**
*
* Modal
*
*/
import React from 'react';
import { Button, Icon, Modal } from 'semantic-ui-react';
import PropTypes from 'prop-types';

const FullModal = ({ actions, title, children, open, onClose, scrolling, size, basic, trigger, hiddenHeader, style }) => (
  <Modal closeOnEscape={false} closeOnRootNodeClick={false} open={open} basic={basic} onClose={onClose} trigger={trigger} closeIcon size={size} style={style}>
    { !hiddenHeader && <Modal.Header>{title}</Modal.Header> }
    <Modal.Content scrolling={scrolling}>
      <Modal.Description>
        {children}
      </Modal.Description>
    </Modal.Content>
    { actions && <Modal.Actions>
      <Button primary>
        Proceed <Icon name="right chevron" />
      </Button>
    </Modal.Actions> }
  </Modal>
);

FullModal.propTypes = {
  /** Modal content */
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  /** Modal title */
  title: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string,
  ]),
  /** Modal is opened */
  open: PropTypes.bool,
  /** Close function */
  onClose: PropTypes.func,
  /** Scrollable content */
  scrolling: PropTypes.bool,
  /** Modal size */
  size: PropTypes.string,
  /** Action footer */
  actions: PropTypes.bool,
  /** Basic form */
  basic: PropTypes.bool,
  /** Trigger button */
  trigger: PropTypes.object,
  /** Hidden header */
  hiddenHeader: PropTypes.bool,
  style: PropTypes.object,
};

export default FullModal;



// WEBPACK FOOTER //
// ./app/components/Modal/index.js